<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Expense Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "Expense Report",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Expense Report",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsExpensesServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "paid",
          sortable: true,
          label: "PAID",
        },
        { key: "balance", label: "BALANCE", sortable: true },
        {
          key: "supplier",
          sortable: true,
          label: "SUPPLIER",
        },
        {
          key: "user",
          sortable: true,
          label: "MADE BY",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE/TIME",
        },
      ],
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        category: "",
      },
      totals: {
        totalAmount: 0,
        totalBalance: 0,
      },
      filterTitle: "",
      filteredReport: [],
      json_fields: {
        CATEGORY: "category",
        TOTAL_AMOUNT: "amount",
        PAID: "paid",
        BALANCE: "balance",
        SUPPLIER: "supplier",
        DESCRIPTION: "description",
        MADE_BY: "user",
        DATE: "date",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    ...mapGetters("expenses", [
      "Expenses",
      "ExpenseCategories",
      "ExpenseCategoriesPagination",
      "ExpenseCategoriesPaginated",
      "SaveStatus",
      "ExpensesPagination",
      "ExpensesPaginated",
    ]),
  
    ...mapGetters("auth", ["business", "branch"]),

    rows() {
      return this.IsExpensesServerPaginated
        ? this.ExpensesPagination?.total
        : this.Expenses
        ? this.Expenses.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsExpensesServerPaginated) {
          const value =
            this.ExpensesPagination?.per_page ||
            this.data.per_page ||
            this.serverPerPage;
          return parseInt(value) || this.serverPerPage;
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsExpensesServerPaginated) {
          this.data.per_page = parseInt(value);
          this.data.page = 1;
          this.FetchExpenses(this.data);
        } else {
          this.serverPerPage = parseInt(value);
        }
      },
    },

    currentPage: {
      get() {
        return this.ExpensesPaginated && this.ExpensesPagination
          ? this.ExpensesPagination?.current_page
          : 1;
      },
      set(value) {
        if (this.ExpensesPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  watch: {
    expenses(newValue) {
      if (newValue.data.length > 0) {
        this.assiginData();
      }
    },
  },

  methods: {
    ...mapActions({
      FetchExpenses: "expenses/fetchExpenses",
      FetchExpenseCategories: "expenses/fetchExpenseCategories",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    assiginData() {
      this.filteredReport = this.Expenses;

      let total = 0;
      this.Expenses
        ? this.Expenses.forEach((value) => {
            let amt = parseInt(value.amount);
            total = total + amt;
          })
        : [];
      this.totals.totalAmount = total;
    },

    filterReport() {
      let payload = { ...this.data };

      payload.page = 1;
      if (!payload.per_page) {
        payload.per_page = this.serverPerPage;
      }

      this.FetchExpenses(payload);
    },

    handlePageChange(newPage) {
      if (this.IsExpensesServerPaginated) {
        this.data.page = newPage;
        this.FetchExpenses(this.data);
      }
    },
  },

  created() {
    this.FetchExpenses(this.data);
    this.FetchExpenseCategories();
    this.assiginData();
  },
};
</script>

<template>
  <Layout>
    <h4 class="text-center text-primary" v-if="business && branch">
      {{ business }} - {{ branch.branch }}
    </h4>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
              <div class="col-3">
                <download-excel
                  class="btn btn-info mt-4"
                  :data="filteredReport"
                  :fields="json_fields"
                  :worksheet="'EXPENSES REPORT FOR ' + currentdate"
                  type="csv"
                  :name="'expenses_report ' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>Expense Category</label>
                  <model-list-select
                    :list="
                      ExpenseCategories
                        ? [
                            { id: '', name: 'All Categories' },
                            ...ExpenseCategories,
                          ]
                        : []
                    "
                    v-model="data.category"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Category"
                    @input="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-1 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="SaveStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0 mt-2">
              <DataTable
                class="datatables"
                :columns="fields"
                :rows="Expenses || []"
                foot-clone
                responsive="sm"
                :total-rows="rows"
                :pagination="ExpensesPagination"
                :server-pagination="IsExpensesServerPaginated"
                :loading="SaveStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(amount)="{ value }">
                  {{ thousandSeprator(value) }}
                </template>

                <template #cell(paid)="{ value }">
                  {{ thousandSeprator(value) }}
                </template>

                <template #cell(balance)="{ value }">
                  {{ thousandSeprator(value) }}
                </template>

                <template #foot(index)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(amount)="">
                  {{ thousandSeprator(totals.totalAmount) }}
                </template>
                <template #foot(balance)="">
                  {{ thousandSeprator(totals.totalBalance) }}
                </template>
                <template #foot(payee_field)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(addedBy)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(dateCreated)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(branch)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(category)="">
                  <span class="text-danger"></span>
                </template>
              </DataTable>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
